import type { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  controls: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "end",
    marginBottom: 16,
  },
  field: {
    display: "grid",
    gap: 6,
  },
  label: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    fontWeight: 600,
  },
  input: {
    padding: "6px 10px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    background: "var(--color-bg)",
    color: "var(--color-text)",
  },
  select: {
    minWidth: 210,
    padding: "6px 10px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    background: "var(--color-bg)",
    color: "var(--color-text)",
  },
  mono: {
    fontFamily: "var(--font-mono)",
    fontSize: 12,
  },
  meta: {
    marginTop: 4,
    fontSize: 12,
    color: "var(--color-text-secondary)",
  },
  statusOk: {
    color: "var(--color-success)",
  },
  statusMuted: {
    color: "var(--color-text-secondary)",
  },
  bodyPreview: {
    maxHeight: 260,
    overflow: "auto",
    padding: 12,
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    background: "var(--color-bg)",
    fontFamily: "var(--font-mono)",
    fontSize: 12,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  detailGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 10,
    marginBottom: 14,
  },
  hint: {
    padding: "24px 0",
    color: "var(--color-text-secondary)",
    fontSize: 14,
  },
  actions: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    marginTop: 12,
  },
};
